import createReducer from '../createReducer';

// SST values are encoded in the tile sets as Kelvin.
// This scale should be passed into the SDK for basic color styling.
// Any conversion to other units should only take place on the legend
const sstScale = [
  { value: 273.15, color: [2, 0, 148] },
  { value: 275.15, color: [0, 0, 204] },
  { value: 277.15, color: [37, 24, 254] },
  { value: 279.15, color: [0, 97, 243] },
  { value: 281.15, color: [0, 148, 255] },
  { value: 283.15, color: [0, 197, 255] },
  { value: 285.15, color: [0, 255, 204] },
  { value: 287.15, color: [0, 255, 153] },
  { value: 289.15, color: [3, 255, 74] },
  { value: 291.15, color: [3, 255, 74] },
  { value: 293.15, color: [51, 255, 0] },
  { value: 295.15, color: [153, 255, 0] },
  { value: 297.15, color: [198, 255, 9] },
  { value: 299.15, color: [255, 255, 0] },
  { value: 301.15, color: [255, 173, 1] },
  { value: 303.15, color: [254, 99, 7] },
  { value: 305.15, color: [255, 73, 0] },
  { value: 307.15, color: [197, 31, 33] },
];


export const initialState = {
  tileLayerOptions: {
    maxZoom: 6,
    minZoom: 1,
    renderTransparentArea: true,
  },
  gradientColoringFragmentOptions: {
    decode: {
      channel: 'r',
      min: 271.0,
      max: 307.15,
    },
    stops: sstScale,
    smooth: false,
    opacity: 1.0,
  },
};

const handlers = {};

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/charts/sst.js